import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { loadConfig } from '../config/config';

export const ModuleAccessContext = createContext();

export const ModuleAccessProvider = ({ children }) => {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchModules = async () => {
    setLoading(true);
    try {
      const config = await loadConfig();
      const apiUrl = config.apiBaseUrl + '/moduleaccess';
      const res = await axios.get(apiUrl);
      setModules(res.data || []);
    } catch (err) {
      setModules([]);
    }
    setLoading(false);
  };

  // Call fetchModules on mount if needed
  useEffect(() => {
    fetchModules();
  }, []);

  return (
    <ModuleAccessContext.Provider value={{ modules, loading, fetchModules }}>
      {children}
    </ModuleAccessContext.Provider>
  );
};